import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import * as React from 'react';

const SvgExclamation24Filled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "currentColor",
  "aria-label": "Exclamation",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2m-1 4.5a1 1 0 0 1 2 0v6a1 1 0 0 1-2 0zM12 18a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5"
}));

export { SvgExclamation24Filled as default };
//# sourceMappingURL=Exclamation24Filled.js.map
